import {httpSubmitLog} from '../services/submitLog.http.ts'
import {chatHighlights} from '../helpers.ts'
import {useEffect} from 'react'
import {errorHandler} from '@utilities/helpers.ts'
import {useChatbotStore} from '../store/chatbotStore.ts'
import {useAuthStore} from '@features/user/store/store.ts'

export const SubmitLog = () => {
    const accessToken = useAuthStore(store => store.accessToken)
    const selectedShoot = useChatbotStore(store => store.selectedAssignment)
    const chatHistory = useChatbotStore(store => store.chatHistory)
    const sessionId = useChatbotStore(store => store.sessionId)
    const setSessionId = useChatbotStore(store => store.setSessionId)
    const flow = chatHistory.map(({id}) => id).join(', ') // whole conversation (ids)
    const recap = chatHistory.map(({message}) => message).join(' --- ') //whole conversation (messages)
    const highlights = chatHighlights(chatHistory) // A string containing the highlights of the session: all actions taken via API calls
    const isTicketOpen = flow.includes('ticket') // A boolean indicating if a ticket has been opened in this session or not

    useEffect(() => {
        // Generate session ID if not already set
        if (!sessionId) {
            setSessionId(Date.now().toString())
        }
        onSubmitLogResults()
    }, [sessionId, setSessionId])

    const onSubmitLogResults = async (): Promise<void> => {
        if (!accessToken) {
            console.error('SubmitLog: Missing access token')
            return
        }

        try {
            const logData = {
                flow: flow || 'general_chat',
                recap: recap || 'No conversation recorded',
                highlights: highlights || 'No highlights',
                ticket: isTicketOpen,
                thread_id: sessionId || Date.now().toString(),
                // Optional fields - only include if available
                ...(selectedShoot?.entity?.id && {entity_id: selectedShoot.entity.id}),
                ...(selectedShoot?.task_media?.id && {task_media_id: selectedShoot.task_media.id.toString()})
            }

            console.log('SubmitLog: Submitting log data:', {
                hasEntityId: !!logData.entity_id,
                hasTaskMediaId: !!logData.task_media_id,
                threadId: logData.thread_id
            })

            await httpSubmitLog(logData)
        } catch (error) {
            errorHandler(error)
        }
    }

    return <div />
}
